module.exports = __webpack_public_path__ + "img/print_nilai.530e1518.svg";